import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';
import { useTopLoader } from 'nextjs-toploader';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'sv'],

  // Used when no locale matches
  defaultLocale: 'sv',
  localeDetection: false,

  localePrefix: 'as-needed',
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
const navigation = createNavigation(routing);

export const { Link, redirect, usePathname, getPathname } = navigation;

export const useRouter = (...args) => {
  const loader = useTopLoader();
  const router = navigation.useRouter(...args);

  return {
    ...router,
    push: (...args) => {
      loader.start();
      return router.push(...args);
    },
    replace: (...args) => {
      loader.start();
      return router.replace(...args);
    },
  };
}
